<div fxLayout="column" fxLayoutGap="24px">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2>{{ create ? 'Create Presentation' : 'Update Presentation' }}</h2>

    <div fxLayout="row" fxLayoutGap="8px">
      <!-- JSON View Button -->
      <button mat-stroked-button (click)="viewAsJson()" matTooltip="View/Edit as JSON">
        <mat-icon>code</mat-icon>
        JSON View
      </button>

      <!-- Predefined Configs Menu -->
      @if (create) {
        <button
          mat-stroked-button
          [matMenuTriggerFor]="templatesMenu"
          matTooltip="Load predefined configuration"
        >
          <mat-icon>template_add</mat-icon>
          Templates
        </button>
        <mat-menu #templatesMenu="matMenu">
          @for (template of predefinedConfigs; track template.name) {
            <div>
              <button mat-menu-item (click)="loadPredefinedConfig(template)">
                <mat-icon>{{ template.icon }}</mat-icon>
                <div fxLayout="column" fxLayoutAlign="start start">
                  <span>{{ template.name }}</span>
                  <small class="menu-description">{{ template.description }}</small>
                </div>
              </button>
              <button mat-menu-item (click)="previewPredefinedConfig(template)">
                <mat-icon>visibility</mat-icon>
                <span>Preview {{ template.name }}</span>
              </button>
              @if (!$last) {
                <mat-divider></mat-divider>
              }
            </div>
          }
        </mat-menu>
      }

      <!-- Back Button -->
      <button mat-icon-button [routerLink]="['../']" matTooltip="Back to list">
        <mat-icon>arrow_back</mat-icon>
      </button>
    </div>
  </div>
  <form
    [formGroup]="form"
    (ngSubmit)="createOrUpdatePresentation()"
    fxLayout="column"
    fxLayoutGap="24px"
  >
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          <mat-icon>settings</mat-icon>
          Basic Information
        </mat-card-title>
      </mat-card-header>

      <mat-card-content fxLayout="column" fxLayoutGap="16px">
        <!-- ID Field -->
        <mat-form-field>
          <mat-label>ID</mat-label>
          <input matInput formControlName="id" placeholder="Enter unique identifier" />
          @if (form.controls['id'].hasError('required')) {
            <mat-error> ID is required </mat-error>
          }
        </mat-form-field>

        <!-- Description Field -->
        <mat-form-field>
          <mat-label>Description</mat-label>
          <input matInput formControlName="description" placeholder="Enter description" />
          @if (form.controls['description'].hasError('required')) {
            <mat-error> Description is required </mat-error>
          }
        </mat-form-field>

        <!-- DCQL Query Field -->
        <h4>DCQL Query</h4>
        <app-editor
          formControlName="dcql_query"
          [schema]="DCQLSchema"
          [errors]="form.get('dcql_query')?.errors"
        ></app-editor>

        <mat-form-field>
          <mat-label>Lifetime of the request</mat-label>
          <input matInput formControlName="lifeTime" type="number" />
          @if (form.controls['lifeTime'].hasError('required')) {
            <mat-error> Lifetime is required </mat-error>
          }
          @if (form.controls['lifeTime'].hasError('min')) {
            <mat-error> Lifetime must be at least 1 </mat-error>
          }
          <mat-hint> Lifetime is in seconds </mat-hint>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Redirect URI (optional)</mat-label>
          <input matInput formControlName="redirectUri" placeholder="Enter redirect URI" />
          <mat-hint>
            If provided, the user will be redirected to this URI after completing the presentation.
          </mat-hint>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-header>
        <mat-card-title>
          <mat-icon>security</mat-icon>
          Registrar
        </mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayout="column" fxLayoutGap="16px">
        <!-- Registration Certificate Field -->
        <h4>Registrar Certificate (optional)</h4>
        <app-editor
          formControlName="registrationCert"
          [schema]="registrationCertificateRequestSchema"
          [errors]="form.controls['registrationCert'].errors"
        ></app-editor>
      </mat-card-content>
    </mat-card>

    <!-- Attachment Configuration Card -->
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          <mat-icon>attach_file</mat-icon>
          Attachments
        </mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayout="column" fxLayoutGap="16px">
        <button mat-button (click)="addAttachment()" type="button">Add Attachment</button>
        <div formArrayName="attached">
          @for (attachmentCtrl of getFormArray('attached').controls; let i = $index; track $index) {
            <app-credential-ids
              [formGroup]="asFormGroup(attachmentCtrl)"
              (removeAttachment)="removeAttachment(i)"
            ></app-credential-ids>
          }
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Webhook Configuration Card -->
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          <mat-icon>webhook</mat-icon>
          Webhook Configuration
        </mat-card-title>
      </mat-card-header>

      <mat-card-content fxLayout="column" fxLayoutGap="16px" formGroupName="webhook">
        <app-webhook-config-edit [group]="getFormGroup('webhook')"></app-webhook-config-edit>
      </mat-card-content>
    </mat-card>

    <!-- Action Buttons -->
    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="end center">
      <button mat-button type="button" [routerLink]="['../']">Cancel</button>
      <button mat-flat-button type="submit" [disabled]="form.invalid">
        <mat-icon>{{ create ? 'add' : 'save' }}</mat-icon>

        {{ create ? 'Create' : 'Save' }} Configuration
      </button>
    </div>
  </form>
</div>
